import { Database, Model } from '@nozbe/watermelondb';

import { ValidationOperation } from '../../../validation/validator';
import {
    EntryEntityTableName,
    ModelByEntryEntityTable,
    RecordByEntryEntityTable,
} from '../../../../types/Entries';

const mapRawRecord = <K extends EntryEntityTableName>(
    record: ModelByEntryEntityTable[K],
) => {
    return record._raw as unknown as RecordByEntryEntityTable[K];
};

const toPreparedDataItems = <K extends EntryEntityTableName>(
    records: ModelByEntryEntityTable[K][],
    table: K,
    operation: ValidationOperation,
) => {
    return records.map((record) => ({
        record,
        table,
        operation,
    }));
};

const addRelatedDataBatch = async (data: Model[], database: Database) => {
    await database.batch(...data);
};

export { toPreparedDataItems, addRelatedDataBatch, mapRawRecord };
